(ns app.survey.no-access)

(defn view
  []
  [:div])
